/**
 * Single source of truth for the calculator's labels, defaults and config.
 *
 * US English, US number formatting (see §13 of the build spec). The wider site is
 * localized via next-intl, but this tool ships US-only by design — currency code
 * lives in one constant so a future multi-currency pass has a single seam.
 */

export const CURRENCY = "USD";

export const STRINGS = {
  toolTitle: "Business loan calculator for traditional lenders",
  loanAmount: "Loan amount",
  interestRate: "Interest rate (APR)",
  repaymentTerm: "Repayment term",
  originationFee: "Origination fee (optional)",
  monthlyPayment: "Monthly payment",
  totalInterest: "Total interest",
  totalRepaid: "Total repaid",
  trueApr: "True APR (incl. fees)",
  scheduleTitle: "Amortization schedule",
  colPeriod: "Period",
  colPrincipal: "Principal",
  colInterest: "Interest",
  colBalance: "Balance",
  byYears: "Years",
  byMonths: "Months",
  disclaimer:
    "*Estimates only. Actual rates, fees, terms, and offers depend on your business and the lender.",
} as const;

/** Input ranges and step sizes. Inputs are clamped to these bounds. */
export const RANGES = {
  amount: { min: 5_000, max: 5_000_000, step: 1_000 },
  rate: { min: 1, max: 40, step: 0.1 },
  termMonths: { min: 3, max: 120, step: 1 },
  originationFee: { min: 0, max: 5, step: 0.1 },
} as const;

/** Defaults tie the loaded state to the article's $100,000 worked example. */
export const DEFAULTS = {
  amount: 100_000,
  ratePct: 9.5,
  termMonths: 84,
  originationFeePct: 2,
} as const;
